import { SHOW_WARNING_BANNER } from "../../constants";

export const showWarningBanner = payload => dispatch => {
  dispatch({
    type: SHOW_WARNING_BANNER,
    payload
  });
};
